interface IDashboardMenus {
  title: string
  icon: string
  path: string
  description?: string
  hidden?: boolean,
  roles: string[] // Changed from single role to array of roles
}

export const SIDEBAR_EXPAND_WIDTH = 280;
export const SIDEBAR_COLLAPSED_WIDTH = 72;

export const APP_MENU: Record<string, { name: string, routes: IDashboardMenus[] }> = {
  main: {
    name: 'Core',
    routes: [
      {
        title: 'Dashboard',
        icon: 'LayoutDashboard',
        path: '/home',
        roles: ['super'],
        description: 'Overview and analytics'
      },
    ],
  },
  settings: {
    name: 'General',
    routes: [
      {
        path: '/users',
        title: 'Accounts',
        icon: 'Users',
        description: 'Manage Accounts',
        roles: ['admin', 'super', 'reader', 'editor']

      },
      {
        path: '/users/quizzes',
        title: 'Quizzes',
        icon: 'CheckSquare',
        description: 'Manage Quizzes',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/inspiration/quizzes',
        title: 'Inspiration Quizzes',
        icon: 'Coffee',
        description: 'Manage Inspiration Quizzes',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/users/engagement-quota',
        title: 'Engagement',
        icon: 'Layers',
        description: 'Manage Engagement',
        roles: ['admin', 'super', 'reader', 'editor']
      },

      // {
      //   path: '/settings',
      //   title: 'Settings',
      //   icon: 'Settings2',
      //   description: 'Settings'
      // },
      {
        path: '/plans',
        title: 'Plans',
        icon: 'Send',
        description: 'Manage plans',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/languages',
        title: 'Languages',
        icon: 'Globe',
        description: 'Manage Languages',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/currencies',
        title: 'Currencies',
        icon: 'DollarSign',
        description: 'Manage Currencies',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/assets',
        title: 'Assets',
        icon: 'Files',
        description: 'Manage files',
        roles: ['admin', 'super', 'reader', 'editor']

      },
      {
        path: '/features',
        title: 'Features',
        icon: 'Star',
        description: 'Manage Features',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      {
        path: '/upcoming/features',
        title: 'Upcoming Features',
        icon: 'Clock',
        description: 'View Upcoming Features',
        roles: ['admin', 'super', 'reader', 'editor']
      },

      {
        path: '/guide/resources',
        title: 'Guide Resources',
        icon: 'BookOpen',
        description: 'Manage Guide Resources',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      
      {
        path: '/quiz/tips',
        title: 'Quiz Tips',
        icon: 'Info',
        description: 'Manage Quiz Tips',
        roles: ['admin', 'super', 'reader', 'editor']
      },
      
      {
        path: '/notifications',
        title: 'Notifications',
        icon: 'Bell',
        description: 'Manage Notifications',
        roles: ['admin', 'super', 'reader', 'editor']
      }

    ],
  },
  // administration: {
  //   name: 'Administration',
  //   routes: [
  //     {
  //       path: '/settings',
  //       title: 'System Settings',
  //       icon: 'Settings2',
  //       description: 'System configuration',
  //       roles: ['super', 'admin'] // Only super and admin can access settings
  //     },
  //     {
  //       path: '/error-logs',
  //       title: 'Error Logs',
  //       icon: 'AlertTriangle',
  //       description: 'View application error logs',
  //       roles: ['super', 'admin', 'editor'] // Readers cannot see error logs
  //     },
  //     {
  //       path: '/roles',
  //       title: 'Roles & Permissions',
  //       icon: 'Shield',
  //       description: 'Manage user roles and permissions',
  //       roles: ['super', 'admin'] // Only super and admin can manage roles
  //     },
  //   ],
  // },
};

export const globalSearch = {
  // Your global search configuration
};


export const canAccessMenuItem = (userRole: string, menuItem: IDashboardMenus): boolean => {
  // Only check the 'roles' property since 'role' doesn't exist in the interface
  if (menuItem.roles && menuItem.roles.length > 0) {
    console.log(menuItem.roles, userRole, "roles")
    return menuItem.roles.includes(userRole);
  }

  // If no roles are specified, allow access by default
  return true;
};